export const FLOW_ADMIN_DETAIL_CHANGE_FLOW_ACTION = 'FLOW_ADMIN_DETAIL_CHANGE_FLOW_ACTION';

export const FETCH_FLOW_ADMIN_DETAIL_INIT = 'FETCH_FLOW_ADMIN_DETAIL_INIT';
export const FETCH_FLOW_ADMIN_DETAIL_SUCCESS = 'FETCH_FLOW_ADMIN_DETAIL_SUCCESS';
export const FETCH_FLOW_ADMIN_DETAIL_FAILURE = 'FETCH_FLOW_ADMIN_DETAIL_FAILURE';

export const BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_INIT = 'BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_INIT';
export const BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_SUCCESS = 'BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_SUCCESS';
export const BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_FAILURE = 'BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_FAILURE';

export const FLOW_ADMIN_DETAIL_VALIDATE_FLOW_INIT = 'FLOW_ADMIN_DETAIL_VALIDATE_FLOW_INIT';
export const FLOW_ADMIN_DETAIL_VALIDATE_FLOW_SUCCESS = 'FLOW_ADMIN_DETAIL_VALIDATE_FLOW_SUCCESS';
export const FLOW_ADMIN_DETAIL_VALIDATE_FLOW_FAILURE = 'FLOW_ADMIN_DETAIL_VALIDATE_FLOW_FAILURE';
export const FLOW_ADMIN_DETAIL_VALIDATE_FLOW_RESET = 'FLOW_ADMIN_DETAIL_VALIDATE_FLOW_RESET';

export const FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_INIT = 'FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_INIT';
export const FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_SUCCESS = 'FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_SUCCESS';
export const FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_FAILURE = 'FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_FAILURE';

export const FLOW_ADMIN_DETAIL_SAVE_STATS_INIT = 'FLOW_ADMIN_DETAIL_SAVE_STATS_INIT';
export const FLOW_ADMIN_DETAIL_SAVE_STATS_SUCCESS = 'FLOW_ADMIN_DETAIL_SAVE_STATS_SUCCESS';
export const FLOW_ADMIN_DETAIL_SAVE_STATS_FAILURE = 'FLOW_ADMIN_DETAIL_SAVE_STATS_FAILURE';

export const FLOW_ADMIN_DETAIL_RESET = 'FLOW_ADMIN_DETAIL_RESET';



// WEBPACK FOOTER //
// ./source/client/actions/flow_admin_detail/types.js